import { rgbToHex } from "../../../Util/ColorUtil";

export const colors = [
    "#F44336",
    "#C62828",
    "#AD1457",
    "#FF1744",
    "#E91E63",
    "#9C27B0",
    "#7B1FA2",
    "#6A1B9A",
    "#4A148C",
    "#AA00FF",
    "#00B0FF",
    "#283593",
    "#3D59FE",
    "#1B237D",
    "#607D8B",
    "#19BC9C",
    "#26A69A",
    "#4FC3F7",
    "#66BB6A",
    "#004D40",
    "#00796B",
    "#2E7D32",
    "#1C5E20",
    "#F7DB69",
    "#E0C341",
    "#FFCB28",
    "#FFA000",
    "#FF5722",
    "#EF6C03",
    "#E64919",
];

export const stringToColor = (val: number): number[] => {
    //--val = 2033
    const r = (val * 1) % 255, //--192
          g = (val * 12) % 255, //--171
          b = (val * 25) % 255; //--150
    return [r, g, b]; //--[192, 171, 150]
};

export const shadeColor = (color: string, percent: number): string => {
    const f = parseInt(color.slice(1), 16),
          t = percent < 0 ? 0 : 255,
          p = percent < 0 ? percent * -1 : percent,
          R = f >> 16,
          G = (f >> 8) & 0x00ff,
          B = f & 0x0000ff;
    return (
        "#"
    + (
        0x1000000
      + (Math.round((t - R) * p) + R) * 0x10000
      + (Math.round((t - G) * p) + G) * 0x100
      + (Math.round((t - B) * p) + B)
    )
        .toString(16)
        .slice(1)
    );
};

export const createGenericIcon = (sourceText: string): Promise<string> => {
    return new Promise((resolve) => {
        const nameArray = sourceText.split(""); //--["W", "a", "l", "m"........etc]
        let nameCharCode = 0;
        for (let i = 0; i < nameArray.length; i++) {
            nameCharCode += sourceText.charCodeAt(i); //--number - ex. 87
        }

        const rgbNameColor = stringToColor(nameCharCode); //--[192, 171, 150]
        const hexNameColor = rgbToHex(
            rgbNameColor[0],
            rgbNameColor[1],
            rgbNameColor[2]
        ); //--"#c0ab96"

        const canvas = document.createElement("canvas"); //--html element - <canvas> - has fill, stroke, etc
        const context = canvas.getContext("2d"); //--CanvasRenderingContext2D { ... }

        canvas.height = 176;
        canvas.width = 176;

        //Gradient
        const hexGrdColor = shadeColor(hexNameColor, 0.5); //--hexGrdColor = "#e0d5cb", hexNameColor = "c0ab96"
        const grd = context.createLinearGradient(0, 0, 17, 0);

        grd.addColorStop(0, hexNameColor);
        grd.addColorStop(1, hexGrdColor);

        const lastThreeChars = sourceText.replace(/ /g, "").slice(-3);
        const lastThreeActualLastIndex = lastThreeChars?.length - 1;
        const hex
      = colors[
          (lastThreeChars[Math.min(0, lastThreeActualLastIndex)].charCodeAt(0)
          + lastThreeChars[Math.min(1, lastThreeActualLastIndex)].charCodeAt(0)
          + lastThreeChars[Math.min(2, lastThreeActualLastIndex)].charCodeAt(0))
          % 30
      ]; //hexGrdColor;//grd;
        context.fillStyle = hex;
        context.fillRect(0, 0, 100, 100);

        const svgXml
      = `<svg xmlns="http://www.w3.org/2000/svg" id="canvasSvg" style="display: none" width="176" height="176" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
              <rect id="a" width="176" height="176" rx="4"/>
          </defs>
          <g fill="none" fill-rule="evenodd">
              <mask id="b" fill="#fff">
              <use xlink:href="#a"/>
              </mask>
              <use fill="`
      + hex
      + `" xlink:href="#a"/>
              <circle fill-opacity=".15" fill="#FFF" mask="url(#b)" cx="182" cy="176" r="141"/>
          </g>
        </svg>`;
        const svg64 = btoa(svgXml);
        const b64Start = "data:image/svg+xml;base64,";
        const image64 = b64Start + svg64;

        const img = document.createElement("img");
        img.src = image64;
        img.onload = () => {
            context.drawImage(img, 0, 0);

            const light = "#FFF";
            let textColor = "";
            textColor = light;

            context.font = "70px sans-serif";
            context.fillStyle = textColor;
            context.textAlign = "center";
            context.textBaseline = "middle";
            context.fillText(sourceText[0], canvas.width / 2, canvas.height / 2);

            resolve(canvas.toDataURL());
        };
    });
};
